define("command-palette/utils/search-commands-result", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.isPartialMatch = isPartialMatch;
  _exports.meetsSearchRequirements = meetsSearchRequirements;
  _exports.scoreSearchResult = scoreSearchResult;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  function isPartialMatch(query, searchTerms) {
    const matches = getPartialMatches(query, searchTerms);
    return matches.length > 0;
  }

  function meetsSearchRequirements(query, mandatoryTerms) {
    if (!mandatoryTerms || mandatoryTerms.length == 0) {
      return true;
    }

    return getExactMatches(query, mandatoryTerms).length > 0;
  }

  function scoreSearchResult(normalizedQuery, command) {
    const partialMatches = getPartialMatches(normalizedQuery, command.searchTerms);
    const exactMatches = getExactMatches(normalizedQuery, command.searchTerms);
    const partialScore = calculateScoreForMatches(partialMatches);
    const exactScore = calculateScoreForMatches(exactMatches);
    return partialScore + exactScore;
  }

  function calculateScoreForMatches(matches) {
    return matches.reduce((acc, match) => {
      return acc + match.value * (1 / (match.index + 1));
    }, 0);
  }

  function getExactMatches(searchQuery, searchTerms) {
    const queryTerms = searchQuery.split(' ').filter(term => term.length > 1);
    const matches = [];
    searchTerms.forEach((term, index) => {
      if (queryTerms.some(queryTerm => term === queryTerm)) {
        const match = {
          term,
          index,
          value: 2
        };
        matches.push(match);
      }
    });
    return matches;
  }

  function getPartialMatches(searchQuery, searchTerms) {
    const queryTerms = searchQuery.split(' ').filter(term => term.length > 1);
    const matches = [];
    searchTerms.forEach((term, index) => {
      if (queryTerms.some(queryTerm => term.includes(queryTerm) && term !== queryTerm)) {
        const match = {
          term,
          index,
          value: 1
        };
        matches.push(match);
      }
    });
    return matches;
  }
});